export enum HttpHeader {
    Accept = 'Accept',
    AssociatedId = 'X-Associated-Id',
    Authorization = 'Authorization',
    ContentType = 'Content-Type',
    RefreshToken = 'X-Sonar-Refresh-Token',
    Shard = 'X-Sonar-Shard',
    Subdomain = 'X-Sonar-Tenant',
    Timezone = 'X-Sonar-TzOffset'
}
